module.exports = __webpack_public_path__ + "static/media/-_successor.8f2a6a49.png";